export default __webpack_public_path__ + "static/media/800x900 2.620f6999.png";